export const en = {
  // Menu
  menuTitle: "Menu",

  // Tabs
  tabAugment: "Augment",
  tabSkill: "Skill",
  tabEnchant: "Enchant",
  tabWeapon: "Weapon",
  tabEquipment: "Compare",
  tabSimulator: "Simulator",
  
  // Augment Panel
  augmentConfig: "Configuration",
  desiredSkills: "Desired skills count (out of 178 total)",
  lifeStones: "Life Stones Inventory",
  stoneLife: "Life",
  stoneMid: "Mid",
  stoneTop: "Top",
  stoneUltimate: "Ult",
  successProbability: "Success Probability",
  probabilityOfSuccess: "Probability of getting at least 1 of {n}:",
  probabilityOfSpecificSuccess: "Probability of getting one skill:",
  withCurrentStones: "with current stones",
  withTotalAugmentations: "with",
  totalAugmentation: "total augmentation",
  totalAugmentationsPlural: "total augmentations",
  lifeStonePrice: "Life Stone price (adena)",
  topGradePrice: "Top-Grade Life Stone price (adena)",
  priceSettings: "Price Settings",
  
  // Augment Analysis
  analysis: "Analysis",
  singleAugmentSuccess: "Single Augment Success Rate",
  expectedAttemptsNeeded: "Expected Attempts Needed",
  expectedCostAdena: "Expected Cost (adena)",
  skillChance1: "1% skill chance",
  skillChance6: "6% skill chance",
  skillChance25: "25% skill chance",
  skillChance100: "100% skill chance",
  
  // Skill Enchant Panel
  skillEnchantMastery: "Skill Enchant Mastery",
  masteryNone: "None",
  targetEnchantLevel: "Target Enchant Level",
  alreadyEnchanted: "Already enchanted",
  currentLevel: "Current level",
  safeLevels: "Safe levels:",
  enchantChances: "Enchant Chances",
  enchantChancesHint: "📖 = book needed · Green = safe level",
  expectedCostSummary: "Expected Cost Summary +{currentLevel} → +{targetLevel}",
  booksGuaranteed: "Books needed (guaranteed)",
  expectedAttempts: "Expected total attempts",
  expectedBooks: "Expected books used",
  expectedBooksCost: "Expected books cost",
  masterySavesPerSkill: "Saves per skill",
  masteryOneTimeCost: "Mastery cost (one-time)",
  masteryBreakEvenVsNone: "vs None",
  masteryBreakEvenVsPrev: "vs",
  afterSkills: "After {n} skills",
  paysOffNow: "1 skill",
  books: "books",
  enchantBookPrice: "Enchant book price (adena)",
  ancientAdenaPrice: "Ancient Adena price (adena)",
  
  // Enchant Panel
  configuration: "Configuration",
  enchantChancesTitle: "Enchant Chances",
  expectedAttemptsTitle: "Expected Attempts to Target",
  regularScrolls: "Regular scrolls",
  itemsNeeded: "items needed",
  blessedScrolls: "Blessed scrolls",
  prices: "Prices",
  itemPrice: "Item price",
  regularScrollPrice: "Regular scroll price",
  blessedScrollPrice: "Blessed scroll price",
  expectedCostComparison: "Expected Cost Comparison",
  regularCost: "Regular (scrolls + items lost)",
  blessedCost: "Blessed (scrolls only)",
  recommendation: "Recommendation",
  recBlessed: "Blessed",
  recRegular: "Regular",
  viewCostPerLevel: "View cost per level",
  hide: "Hide",
  levelCol: "Level",
  scrollsCol: "Scrolls",
  regularCol: "Regular",
  blessedCol: "Blessed",
  
  // Simulator Panel
  sim_instruction: "Select a Life Stone and click Augment",
  sim_success: "Augmentation was successful!",
  sim_loading: "Loading Sounds...",
  sim_augmenting: "Augmenting...",
  sim_augment_btn: "AUGMENT",
  sim_used: "Used",
  sim_skill_rate: "Skill %",
  sim_best: "Best",
  sim_worst: "Worst",
  sim_history: "RECENT AUGMENTATIONS",
  sim_mute: "Mute sounds",
  sim_unmute: "Unmute sounds",

  // Equipment Panel
  equip_weapon: "Weapon",
  equip_armor: "Armor",
  equip_jewelry: "Jewelry",
  weaponType: "WEAPON TYPE",
  armorType: "ARMOR TYPE",
  myWeapon: "MY WEAPON",
  myArmor: "MY ARMOR SET",
  myJewelrySet: "MY JEWELRY SET",
  myJewelryPiece: "MY JEWELRY",
  compareTo: "COMPARES TO",
  crossoverAt: "Catches up at",
  diffAt: "Crossover",
  enchantLevel: "Enchant",
  jewelry_sets: "Sets",
  jewelry_individual: "Individual",
  jewelry_necklace: "Necklace",
  jewelry_earring: "Earring",
  jewelry_ring: "Ring",
  jewelryPieceType: "PIECE TYPE",
  armor_heavy: "Heavy",
  armor_light: "Light",
  armor_robe: "Robe",
  weapon_sword: "Sword",
  weapon_blunt: "Blunt",
  weapon_dagger: "Dagger",
  weapon_pike: "Pike",
  weapon_fist: "Fist",
  weapon_dual: "Dual",
  weapon_bow: "Bow",
  weapon_mage: "Mage",
  hideBreakdown: "Hide table",
  viewAllLevels: "Show full table",

  // Wiki Panel
  tabWiki: "Wiki",
  wikiSection_events: "Events",
  wikiSection_marks: "Marks",

  // Events Schedule
  eventsServerTime: "Server time",
  eventsLocalTime: "Your time",
  eventsYourTime: "Local",
  eventsServerTimeHeader: "Server",
  eventsEventName: "Event",
  eventsRecentPast: "Recent",
  eventsNow: "NOW",
  eventsToday: "Today",
  eventsTomorrow: "Tomorrow",
  eventsNote: "Times shown in server time (GMT+3) and your local timezone. Schedule updates every minute.",
  wikiMarksIntro: "Marks give random stats at +5, +7, +9. Tier 1 stats double at +6 and again at +8. Tier 2 stats double at +8. At +10 you get a fixed stat.",
  wikiStatName: "Stat",
  wikiMarkNote: "One random stat per tier. Tier 1 also doubles at +8.",
  wikiFixedStat: "fixed",
  wikiPlain: "Mark",
  wikiEnchantBonuses: "Enchant Bonuses",
  wikiAllStats: "all stats",
  wikiRandomStat: "one random",
  wikiMark_avadon: "Mark of Avadon",
  wikiMark_speed: "Mark of Speed",
  wikiMark_hunter: "Mark of Hunter",
  wikiMark_defender: "Mark of Defender",
  wikiMark_divine: "Mark of Divine",
  wikiMark_doom: "Mark of Doom",
  wikiMark_immunity: "Mark of Immunity",
  wikiMark_power: "Mark of Power",
  wikiMark_blood: "Mark of Blood",

  // Keyboard
  done: "Done"
};
